import { createPromiseQueue } from '@startlibs/utils'

export const processQueue = createPromiseQueue()

export const uploadQueue = createPromiseQueue(2)
